import { Helmet } from 'react-helmet-async'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { validateAppleMerchant } from '../../../api/applePay'
import { applePaymentRequestParams } from '../../../config/payment/applePay'
import { setOpenBuyQrTyModal, setOpenPaymentModal } from '../../../redux/slices/modal'
import { store } from '../../../redux/store'
import { payWithApple } from '../../../redux/thunks/qr'

const ApplePayButton = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleApplePayment = () => {
    try {
      const ApplePaySession = window.ApplePaySession

      if (!ApplePaySession?.canMakePayments()) {
        throw new Error('Apple Pay is not supported on this device.')
      }
      // if (window.location.protocol !== 'https:') {
      //   throw new Error('Apple Pay requires a secure (HTTPS) connection.')
      // }

      const request = structuredClone(applePaymentRequestParams)
      const totalPrice = store.getState().qr.totalPrice
      request.total.amount = String(totalPrice)
      // console.log(request)

      const session = new ApplePaySession(3, request)
      session.begin()

      session.oncancel = (event) => {
        console.log('Payment cancelled')
        console.log(event)
      }

      session.onvalidatemerchant = async (event) => {
        console.log('validate merchant')
        // console.log(event)
        const url = event.validationURL
        try {
          const merchantSession = await validateAppleMerchant({ url })
          console.log(merchantSession)
          session.completeMerchantValidation(merchantSession)
        } catch (err) {
          console.log(err)
          session.abort()
        }
        // session.completeMerchantValidation({})
      }

      session.onpaymentauthorized = async (event) => {
        console.log('payment authorized')
        console.log(event)
        const token = event.payment.token
        if (token) {
          await dispatch(payWithApple({ token }))
            .unwrap()
            .then((originalPromiseResult) => {
              console.log(originalPromiseResult)
              session.completePayment({ status: ApplePaySession.STATUS_SUCCESS })
              dispatch(setOpenPaymentModal(false))
              dispatch(setOpenBuyQrTyModal(true))
              navigate('tickets')
            })
            .catch((rejectedValueOrSerializedError) => {})
        } else {
          session.completePayment({ status: ApplePaySession.STATUS_FAILURE })
        }
      }
    } catch (error) {
      console.error('Apple Pay Error: ' + error?.message)
      toast.error('Apple Pay Error: ' + error?.message)
    }
  }

  return (
    <>
      <Helmet>
        <script
          crossorigin
          src="https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js"
        />
      </Helmet>

      {window?.ApplePaySession && (
        <button
          onClick={handleApplePayment}
          style={{
            WebkitAppearance: '-apple-pay-button',
            ApplePayButtonType: 'plain',
            ApplePayButtonStyle: 'white-outline',
            // ApplePayButtonLocale: 'uk-UA',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
          className="payment_button apple_pay_button"
          // lang="uk-UA"
          locale="uk-UA"
          type="button"
        />
      )}
    </>
  )
}

export default ApplePayButton
